// Entry point for the build script in your package.json
//import "@hotwired/turbo-rails"
import "@fortawesome/fontawesome-free/js/all"
import * as bootstrap from "bootstrap/dist/js/bootstrap"
import TomSelect from "tom-select/dist/js/tom-select.complete.min.js"
import "./utils/device"
import "./controllers"
import './compilers'

// Expose the bootstrap object for the Rails UJS library
window.bootstrap = bootstrap;
window.TomSelect = TomSelect;